import SmallVideo from "./SmallVideo";
import { Link, useNavigate} from 'react-router-dom';
import configData from '../config.json';

// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const CategoryPreview = ({ category, 
                           setActiveCategory, 
                           setActiveVideo }) => {

  const changeActiveCategory = (catVideo) => {

    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO_URL, JSON.stringify(catVideo.url));
    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(catVideo));
    localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(category));       

    setActiveCategory(category);
    setActiveVideo(catVideo);
  };

  let navigate = useNavigate(); 
  const navigateTo = () =>{ 
    var path = '/' + (category.flatName).replace(/\s/g, '-');
    navigate(path);
  }

  var categoryStyleClass = "container " + category.styleClass;

  const scroll = () => {
    window.scrollTo({top: 0, left: 0});
  };

  return (
  <>

    <div className={categoryStyleClass}>
        <div className="row mb-3">
            <div className="col" data-aos="fade-right" data-aos-delay="400">    
                <h2 className="d-category-title">
                  <span className="d-title">{category.name}</span> 
                    <a onClick={()=>{changeActiveCategory(category.videos[0]); navigateTo(); scroll();}} className="btn btn-d-transparent-white btn-see-all">
                      Več
                      <i className="fa-regular fa-angle-right ms-1"></i>
                    </a>
                </h2>
                <div className="row"><div className="col-md-6">
                    <p className="d-category-description">{category.description} </p>              
                </div>
            </div>
            </div>
        </div>
            {/* <!-- Swipper --> */}
                <div className="row">
                    <div className="col">

                    <Swiper
                      modules={[Navigation, Pagination, Scrollbar, A11y]}
                      slidesPerView={1}
                      spaceBetween={50}
                      className="d-row-video-thumbnails-slider"
                      navigation={true}
                      breakpoints={{
                        576: {
                          slidesPerView: 2,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        992: {
                          slidesPerView: 4,
                        },
                      }}
                    >
                      {category.videos.map((video) => (
                          <SwiperSlide key={video.id}>
                              <SmallVideo video={video} 
                                          activeCategory={category}
                                          setActiveCategory={setActiveCategory}
                                          setActiveVideo={setActiveVideo}
                                          fromPage='home'
                              />
                          </SwiperSlide>
                        ))} 
                    </Swiper>
                    </div>
                </div>     
    </div>
    </>
    );
  };
  
  export default CategoryPreview;